import {decrypt} from "../../../utils/crypto";
import {dependencies} from "../staticEntities";

const _ = require('lodash')
const path = require("path")
const moment = require('moment')
const mediaDirPath = path.join(global.appRoot, global.isProd ? "buildServer/server/models/fncs/mails/media" : "src/server/models/fncs/mails/media")
const { reallocationTemplatesDirectoryPath} = require('./utils')

const civilityEntity = dependencies.find(entity => entity.name === 'Civility')

const getQueryFromStatus = (object, modelId) => {
    switch (object.status) {
        case 'ongoing':
            return {'authorizations.modules': {$elemMatch: {$eq: `m-${modelId}-reallocationValidation`}}}
        case 'rectification':
        case 'validated':
        case 'refused':
        case 'waitingPayment':
        case 'refundCompleted':
        case 'waitingRefund':
            return {_id: new global.ObjectID(object.beneficiary.id)}
        default:
            return {_id: null}
    }
}

export async function workflowMailing(reallocation, files, context) {
    const groupId = context.group.id
    const modelId = context.model.id
    const cUsers = await global.app.R.CUser.collection
        .aggregate([
            { '$lookup': {
                    'from': 'profile',
                    'let': { 'authId': '$authorizations' },
                    'pipeline': [
                        { '$match': { '$expr': { '$in': ['$_id', '$$authId'] } } }
                    ],
                    'as':'authorizations'
                }
            },
            {
                $match: {
                    group: new ObjectID(groupId),
                    ...getQueryFromStatus(reallocation, modelId)
                }
            },
        ])
        .toArray()

    const subjectUser = ['validated', 'refused', 'rectification', 'waitingPayment'].includes(reallocation.status)
        ? 'myCSEManCo'
        : `${reallocation.beneficiary.firstname} ${reallocation.beneficiary.lastname}`

    sendMails({
        users: cUsers,
        translate: context.tl,
        subjectUser: subjectUser,
        status: reallocation.status,
        refund: reallocation.refund,
        object: reallocation,
        contextUser: context.user,
        template: `${reallocation.status}Reallocation.html`,
        url: global.isProd
            ? `https://${context.host}/business/${context.groupModel.id}`
            : `http://localhost:3000/business/${context.groupModel.id}`
    })
}

const sendMails = ({ users, translate, subjectUser, object, refund, template, url, attachments, contextUser }) => {
    const logMessage = () => {
        console.log('...Mailing')
    }
    const {reference, status, date} = object

    const RIB = ['refundCompleted', 'waitingPayment'].includes(status)
        ? [{path: mediaDirPath + '/RIB_CSE.png'}]
        : []

    users.forEach(user => {
        const language = user.language || 'fr'
        const civilityObject = civilityEntity.objects.find(obj =>obj.id === user.civility)
        const mail = _.defaults(
            {
                to: user.mail && decrypt(user.mail),
                context: {
                    user: user,
                    civility: translate(civilityObject.id || user.civility, language),
                    lastname : user.lastname,
                    contextUser,
                    object,
                    date: moment(date.split(' ')[0]).format('DD/MM/YYYY'),
                    comment: 'fake',
                    refund,
                    url
                },
                content: template,
                subject: {
                    template: ` ${subjectUser} : ${translate('reallocationRequest', language)} ${reference} (${translate(status, language)})`
                },
                templateDir: reallocationTemplatesDirectoryPath(language),
                attachments: [...RIB]
            },
            defaultMail
        )

        global.mailer.sendMail(mail, logMessage)
    })
}

const defaultMail = {
    from: '"myCSEManCo" <assistance@mycsemanco.com>',
    replyTo: 'assistance@mycsemanco.com',
    verbose: {
        general: true
    }
}
